import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { metaFor } from './measurementMeta';

export default function MeasurementPicker({ fields, selected, onSelect }) {
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={selected}
      onChange={(_e, value) => { if (value) onSelect(value); }}
      sx={{ flexWrap: 'wrap', mb: 2 }}
    >
      {fields.map((f) => (
        <ToggleButton key={f} value={f}>{metaFor(f).label}</ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}

MeasurementPicker.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};
